import { render, staticRenderFns } from "./waterRegime.vue?vue&type=template&id=1f42af71&scoped=true&"
import script from "./waterRegime.vue?vue&type=script&lang=js&"
export * from "./waterRegime.vue?vue&type=script&lang=js&"
import style0 from "./waterRegime.vue?vue&type=style&index=0&id=1f42af71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42af71",
  null
  
)

export default component.exports